<template>
  <div class="plane-submit-order" :class="{ isiOSX: isiOSX }">
    <van-row class="detailTitle">
      <img @click="reBack" class="back" src="../../assets/plane/reBack.png" />
      <van-col class="target" span="24">
        <p class="space">
          {{ planeLists.info.departure_city_name }}
          <img src="../../assets/plane/target@2x.png" />
          {{ planeLists.info.arrive_city_name }}
        </p>
        <p class="date">{{ departureTime(planeLists, 0) }}</p>
      </van-col>
    </van-row>
    <van-row class="allList" :class="{ keyboard: iskeyboard }">
      <van-cell class="msg" span="24">
        <div class="oilList">
          <p class="company">
            <img :src="planeLists.info.air_comImage_url" />
            <span class="name">
              {{ planeLists.info.airline_company + planeLists.info.flight_no }}
            </span>
            {{ planeLists.info.craft_type_name || planeLists.info.craft_type }}
            <span v-if="planeLists.info.plane_model">
              (
              <span v-if="planeLists.info.plane_model == 1">大</span>
              <span v-if="planeLists.info.plane_model == 2">中</span>
              <span v-if="planeLists.info.plane_model == 3">小</span>
              <span v-if="planeLists.info.plane_model == 0">其他</span>)
            </span>
            <span v-else>(其他)</span>
            <span class="right">
              {{ planeLists.price.cabin_type }}
              <!-- <span class="reback">返</span> -->
            </span>
          </p>
          <div class="airline">
            <p>
              <span class="edge">
                <span class="date">{{ departureTime(planeLists, 1) }}</span>
                <span class="city">
                  {{ planeLists.info.departure_city_name }}
                </span>
                <span class="time">{{ planeLists.info.departure_time }}</span>
                <span class="airport">
                  {{
                    planeLists.info.departure_port_came +
                    planeLists.info.departure_terminal
                  }}
                </span>
              </span>
              <span class="middle">
                <span>{{ planeLists.info.flight_time1 }}钟</span>
                <img
                  v-if="planeLists.info.stop_num == 0"
                  src="../../assets/plane/aircraft.png"
                />
                <img
                  v-if="
                    planeLists.info.stop_num != 0 &&
                    !planeLists.info.stop_points[0].flight_no1
                  "
                  src="../../assets/plane/stop.png"
                />
                <img
                  v-if="
                    planeLists.info.stop_num != 0 &&
                    planeLists.info.stop_points[0].flight_no1
                  "
                  src="../../assets/plane/stop_long.png"
                />
              </span>
              <span class="edge">
                <span class="date">{{ departureTime(planeLists, 2) }}</span>
                <span class="city">{{ planeLists.info.arrive_city_name }}</span>
                <span class="time">{{ planeLists.info.arrive_time }}</span>
                <span class="airport">
                  {{
                    planeLists.info.arrive_port_name +
                    planeLists.info.arrive_terminal
                  }}
                </span>
              </span>
            </p>
          </div>
        </div>
      </van-cell>
      <van-cell class="fuelOil" span="24">
        机建
        <span>
          ¥{{
            planeLists.price.price_list[0].airport_tax +
            planeLists.price.price_list[0].fuel_tax
          }}
        </span>
      </van-cell>
      <van-col span="24">
        <van-cell-group class="opportunityPerson">
          <p @click="addPerson">
            <span class="left">乘机人</span>
            <span class="right">
              选择乘机人
              <span class="surplus">
                (余
                <b class="cabinNumber">{{ planeLists.price.cabin_number }}</b
                >张)
              </span>
              (最多可添加{{ max_preson }}人)
            </span>
            <img src="../../assets/plane/addperson.png" />
          </p>

          <div
            v-for="(passenger, index) in passengerLists"
            class="passengers"
            :key="index"
          >
            <div>
              {{
                passenger.name +
                "（" +
                passenger.adult +
                "）" +
                passenger.id_number
              }}
            </div>
            <div @click="deletePassenger(index)">
              <van-icon name="cross" />
            </div>
          </div>
          <van-field
            v-model="contact"
            label="联系人"
            placeholder="用于核验订单身份信息"
            @focus="keyboard"
          />
          <van-field
            v-model="tel"
            label="联系电话"
            maxlength="11"
            type="number"
            placeholder="用于接收订单/航变信息"
            @focus="keyboard"
          />
          <van-field
            v-model="iscqzjh"
            v-if="iscq"
            label="联系人证件号"
            placeholder="用于核验订单身份信息"
            @focus="keyboard"
          />
        </van-cell-group>
      </van-col>
      <!--<van-cell class="Insurance" span="24">
        <p v-for="(plans,index) in insuranceLists" :key="index">
          <img @click="openDialog" src="../../assets/plane/notes.png" />
          {{plans.name}}
          <span>
            ¥{{plans.price}}/人
            <img
              @click="confirm(plans, index)"
              v-if="!plans.selected"
              src="../../assets/plane/noselect@2x.png"
            />
            <img @click="confirm(plans, index)" v-if="plans.selected" src="../../assets/plane/delected@2x.png" />
          </span>
          <van-dialog v-model="show" :title="plans.name">
            <p class="insurance_p">{{plans.remark.slice(0,16)}}</p>
            <p class="insurance_p">{{plans.remark.slice(16)}}</p>
            <p @click="show=false" class="insurance_btn">我知道了</p>
          </van-dialog>
        </p>
      </van-cell>-->
      <van-cell class="agreement">
        <img
          @click="argees"
          v-if="!agree"
          src="../../assets/plane/noselect@2x.png"
        />
        <img
          @click="argees"
          v-if="agree"
          src="../../assets/plane/delected@2x.png"
        />
        同意
        <span @click="aggre('sanfang_jipiao_ldcjwxxz')"
          >《锂电池及危险品须知》</span
        >、
        <span @click="aggre('sanfang_jipiao_tslvkgpxz')"
          >《特殊旅客购票须知》</span
        >以及
        <span @click="aggre('sanfang_jipiao_xbgpxz')">《销巴购票须知》</span>
      </van-cell>
      <van-cell class="tip">
        <p class="title">积分赠送：</p>
        <p class="con">在您的订单完成后，您可到订单页面主动领取积分。</p>
      </van-cell>
    </van-row>
    <div class="submit">
      <p>
        合计：
        <span class="money">
          ￥
          <span class="price">{{ amountes }}</span>
          <span class="decimal">.00</span>
        </span>
        <span class="detailed" @click="priceDetail()">
          价格明细
          <img src="../../assets/plane/jiantou.png" />
        </span>
        <button ref="btn" @click="toPay()" style="display: none"></button>
        <!--<span>价格明细</span>-->
        <span
          v-if="!createOrder"
          class="btn"
          @click="payfor(planeLists, passengerLists)"
          >立即支付</span
        >
        <van-button
          v-if="createOrder"
          class="btn btn1"
          loading
          type="info"
          loading-text="校验中..."
        />
      </p>
    </div>
    <van-popup v-model="spacePop" position="bottom" :overlay="true">
      <van-row>
        <van-col class="title" span="24">价格明细</van-col>
        <van-col class="list" span="24" v-if="proceDetail[0].length > 0">
          <div>
            <span>成人票</span>
            <span class="right">
              ￥{{ proceDetail[0].price }}
              <span>x {{ proceDetail[0].length }} 人</span>
            </span>
          </div>
        </van-col>
        <van-col class="list" span="24" v-if="proceDetail[1].length > 0">
          <div>
            <span>儿童票</span>
            <span class="right">
              ￥{{ proceDetail[1].price }}
              <span>x {{ proceDetail[1].length }} 人</span>
            </span>
          </div>
        </van-col>
        <van-col class="list" span="24" v-if="proceDetail[2].length > 0">
          <div>
            <span>婴儿票</span>
            <span class="right">
              ￥{{ proceDetail[2].price }}
              <span>x {{ proceDetail[2].length }} 人</span>
            </span>
          </div>
        </van-col>
        <van-col class="list" span="24" v-if="proceDetail[0].length > 0">
          <div>
            <span>基建</span>
            <span class="right">
              ￥{{ proceDetail[0].fuel_tax }}
              <span>x {{ proceDetail[0].length }} 人</span>
            </span>
          </div>
        </van-col>
        <van-col
          class="list"
          span="24"
          v-if="proceDetail[1].length > 0 && proceDetail[1].fuel_tax > 0"
        >
          <div>
            <span>基建</span>
            <span class="right">
              ￥{{ proceDetail[1].fuel_tax }}
              <span>x {{ proceDetail[1].length }} 人</span>
            </span>
          </div>
        </van-col>
      </van-row>
    </van-popup>
    <van-popup class="tipMSG" v-model="showTip">
      <div class="box">
        <img src="../../assets/common/BG@2x.png" alt />
        <p class="title">温馨提示</p>
        <p class="tips">{{ TipMsg }}</p>
        <span v-if="order_already == 2" class="left" @click="cancle()"
          >取消</span
        >
        <span v-if="order_already == 2" class="right" @click="confirm()"
          >确定</span
        >
        <span
          v-if="order_already == 1"
          class="right right_big"
          @click="confirm_order()"
          >确定</span
        >
      </div>
    </van-popup>
    <div class="loading" v-if="loading">
      <img src="../../assets/common/loading.gif" />
    </div>
    <!-- 优化，增加弹窗 -->
    <van-dialog
      v-model="submintShow"
      title="正在生成订单"
      :showConfirmButton="false"
    >
      <div class="submintShowStyle">
        <ul>
          <li>订单信息</li>
          <li v-if="loadingItem1">
            <span
              >{{ planeLists.info.departure_city_name }} -
              {{ planeLists.info.arrive_city_name }}</span
            >
            <img src="../../assets/plane/submintShowIcon.png" alt srcset />
          </li>
          <li v-if="loadingItem2">
            <span>{{ planeLists.info.departure_date }}</span>
            <img src="../../assets/plane/submintShowIcon.png" alt srcset />
          </li>
          <li v-if="loadingItem3">
            <span
              >{{ planeLists.info.flight_no }}
              {{ planeLists.info.departure_time }}起飞</span
            >
            <img src="../../assets/plane/submintShowIcon.png" alt srcset />
          </li>
          <li v-if="loadingItem4">
            <span
              >乘机人{{ passengerLists ? passengerLists.length : 0 }}位</span
            >
            <img src="../../assets/plane/submintShowIcon.png" alt srcset />
          </li>
          <li v-if="loadingItem5">
            <div>
              <img
                src="../../assets/plane/spin.png"
                class="turn"
                alt
                srcset
              />正在提交，请耐心等待…
            </div>
          </li>
          <li v-if="loadingItem6">
            <div>
              <img
                src="../../assets/plane/submintShowIcon.png"
                alt
                srcset
              />订单已经提交
            </div>
          </li>
        </ul>
      </div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      isChecked: false,
      like: false,
      Insurance: false,
      agree: false,
      planeLists: {},
      passengerLists: undefined,
      insuranceLists: [],
      show: false,
      contact: "",
      tel: "",
      iscqzjh: "", //春秋航班联系人证件号
      //保险费
      insuranceMouny: 0,
      //选中的保险下标
      insuranceIndex: -1,
      noselect: true,
      delected: false,
      checkCabin: {},
      isiOSX: false,
      orderInfo: "",
      adults: [],
      childs: [],
      babys: [],
      client: 0, //客户端类型 10：安卓 11：APPIOS 12：wap 13：小程序 20：pc
      createOrder: false,
      spacePop: false,
      proceDetail: [
        {
          length: 0,
          price: 0, //不含税价
          adultPrice: 0, //含税价
          fuel_tax: 50,
        },
        {
          length: 0,
          price: 0,
          childPrice: 0,
          fuel_tax: 0,
        },
        {
          length: 0,
          price: 0,
          babyPrice: 0,
          fuel_tax: 0,
        },
      ],
      max_preson: "", //成人最大数量
      max_child: 0, //儿童最大数量
      max_baby: 0, //婴儿最大数量
      notBuyOfNum: false,
      toastMsg: "",
      showTip: false,
      TipMsg: "",
      tipBack: 1,
      order_already: 0, //控制弹框按钮的个数显示
      amountes: 0,
      iscq: false, //是否是春秋航班
      iskeyboard: false, //联系人是否获得焦点
      submintShow: false,
      loadingItem1: false,
      loadingItem2: false,
      loadingItem3: false,
      loadingItem4: false,
      loadingItem5: true,
      loadingItem6: false,
    };
  },
  created() {
    this.handleInput();
    this.isiOSX = this.isIphoneX();
    this.planeLists = JSON.parse(sessionStorage.getItem("create"));
    console.log(this.planeLists);
    if (this.planeLists.info.airline_company.slice(0, 2) == "春秋") {
      this.iscq = true;
      // console.log('春秋航班')
    } else {
      this.iscq = false;
      // console.log('其他航班')
    }
    this.passengerLists = JSON.parse(sessionStorage.getItem("passengerLists"));
    var ua = navigator.userAgent.toLowerCase();
    if (/iphone|ipad|ipod|macintosh/i.test(ua)) {
      this.client = 11;
    } else if (/android/.test(ua)) {
      this.client = 10;
    }
    var contractInfo = JSON.parse(sessionStorage.getItem("contactInfo"));
    if (contractInfo) {
      this.contact = contractInfo.contact || "";
      this.tel = contractInfo.tel || "";
    }
    var priceList = this.planeLists.price.allow_personnel_info;

    for (var i in priceList) {
      if (priceList[i].allow_personnel_type == "ADT") {
        if (
          this.planeLists.price.cabin_number > priceList[i].max_count &&
          priceList[i].max_count != 0
        ) {
          this.max_preson = priceList[i].max_count;
        } else {
          this.max_preson = this.planeLists.price.cabin_number;
        }
      } else if (priceList[i].allow_personnel_type == "CHD") {
        if (
          this.planeLists.price.child_cabin_status > priceList[i].max_count &&
          priceList[i].max_count != 0
        ) {
          this.max_child = priceList[i].max_count;
        } else {
          this.max_child = this.planeLists.price.child_cabin_status;
        }
      } else if (priceList[i].allow_personnel_type == "INF") {
        if (
          this.planeLists.price.baby_cabin_number > priceList[i].max_count &&
          priceList[i].max_count != 0
        ) {
          this.max_baby = priceList[i].max_count;
        } else {
          this.max_baby = this.planeLists.price.baby_cabin_number;
        }
      }
    }
  },
  methods: {
    handleInput() {
      window.addEventListener("resize", function () {
        window.setTimeout(function () {
          document.activeElement.scrollIntoView(false);
        }, 1);
      });
    },
    showPopup(msg, index) {
      this.showTip = true;
      this.TipMsg = msg;
      this.tipBack = index;
    },
    cancle() {
      this.showTip = false;
    },
    confirm() {
      this.showTip = false;
      this.order_already = 0;
      if (this.tipBack == 1) {
        this.$router.go(-1);
      } else if (this.tipBack == 2) {
        this.$router.go(-2);
      } else {
        this.cancle();
      }
    },
    confirm_order() {
      this.showTip = false;
      this.order_already = 0;
      if (this.tipBack == 2) {
        //"机票下单失败：国内订单占位失败：订单重复提交"
        this.$router.go(-2);
      } else if (this.tipBack == 4) {
        //"机票下单失败：国内订单占位失败：存在乘客[朱海丽]重复下单"    原因：查询id（取航班列表接口返回query_id）  或   航班缓存id（取舱位接口返回query_id 重复使用导致的）
        this.$router.push({
          path: "/plane/order/list",
          query: {
            back: this.tipBack,
            token: localStorage.getItem("_token"),
          },
        });
      }
    },
    reBack() {
      this.$router.go(-1);
    },
    departureTime(params, otherData) {
      if (otherData == 2) {
        var date = new Date(params.info.arrive_date);
      } else {
        var date = new Date(params.info.departure_date);
      }
      var mouth = date.getMonth() + 1;
      var day = date.getDate();
      var week = date.getDay();
      switch (week) {
        case 1:
          week = "周一";
          break;
        case 2:
          week = "周二";
          break;
        case 3:
          week = "周三";
          break;
        case 4:
          week = "周四";
          break;
        case 5:
          week = "周五";
          break;
        case 6:
          week = "周六";
          break;
        default:
          week = "周日";
      }

      if (otherData != 0) {
        return (
          (mouth < 10 ? "0" + mouth : mouth) +
          "-" +
          (day < 10 ? "0" + day : day) +
          week
        );
      } else {
        return (
          (mouth < 10 ? "0" + mouth : mouth) +
          "月" +
          (day < 10 ? "0" + day : day) +
          "日" +
          " " +
          week
        );
      }
    },
    //添加乘机人
    addPerson() {
      var contactInfo = {
        contact: this.contact,
        tel: this.tel,
      };
      sessionStorage.setItem("contactInfo", JSON.stringify(contactInfo));
      this.$router.push("/choose/passenger");
    },
    deletePassenger(index) {
      this.passengerLists.splice(index, 1);
      this.insuranceLists.forEach((a) => {
        a.selected = false;
      });
      sessionStorage.setItem(
        "passengerLists",
        JSON.stringify(this.passengerLists)
      );
      this.isChecked = true;
      this.notBuyOfNum = false;
      this.account();
    },
    aggre(type) {
      var contactInfo = {
        contact: this.contact,
        tel: this.tel,
      };
      sessionStorage.setItem("contactInfo", JSON.stringify(contactInfo));
      this.$router.push({
        path: "/cms-agreement/detail",
        query: {
          number: type,
          isApp: "1",
        },
      });
    },
    //获取保险信息
    /*getInsurance() {
      this.$api
        .post("/air/member/booking/insurance/list")
        .then(res => {
          this.insuranceLists = res.list;
        })
        .catch(err => {
        });
    },*/
    openDialog() {
      this.show = true;
    },
    //选择保险
    //  confirm(plans, index) {
    //
    //    if (this.passengerLists == null || this.passengerLists == []) {
    //      this.$toast("请选择乘机人");
    //    }
    //    if(this.passengerLists){
    //    	for(let i in this.insuranceLists) {
    //    		if(i == index) {
    //    			if(this.insuranceLists[i].selected){
    //		          this.insuranceLists[i].selected=false
    //		          this.insuranceMouny=0;
    //		          this.insuranceIndex = -1;
    //		        }else{
    //		        	this.insuranceIndex = i;
    //		          this.insuranceLists[i].selected=true
    //		          this.insuranceMouny = this.insuranceLists[i].price;
    //		        }
    //    		}else {
    //    			this.insuranceLists[i].selected=false;
    //		        this.insuranceIndex = -1;
    //    		}
    //    	}
    //      this.insuranceLists=[...this.insuranceLists]
    //    }
    //  },
    argees() {
      this.agree = !this.agree;
      this.iskeyboard = false;
    },
    //支付订单
    payfor(planeLists, passengerLists, insuranceLists) {
      if (this.passengerLists == undefined || this.passengerLists == false) {
        this.$toast("请选择乘机人");
      } else if (this.contact == "") {
        this.$toast("请添加联系人");
      } else if (this.tel == "") {
        this.$toast("请添加联系方式");
      } else if (this.iscq && this.iscqzjh == "") {
        this.$toast("请添加联系人证件号");
      } else if (this.iscq && this.iscqzjh[17] == "x") {
        this.$toast("联系人证件号字母应为大写");
      } else if (this.iscq && !this.checkIDCard(this.iscqzjh)) {
        this.$toast("联系人证件号不合法");
      } else if (this.agree == false) {
        this.$toast(
          "请先同意《锂电池及危险品须知》、《特殊旅客购票须知》以及《销巴购票须知》"
        );
      } else if (this.notBuyOfNum) {
        this.$toast({
          message: this.toastMsg,
          duration: 3000,
        });
      } else {
        passengerLists.forEach((_) => {
          //      delete _.adult;
          delete _.userSex;
          delete _.selected;
          delete _.userIDcard;
          _.birthday =
            _.birthday.slice(0, 4) +
            "-" +
            _.birthday.slice(5, 7) +
            "-" +
            _.birthday.slice(8, 10);
        });
        this.createOrder = true;
        this.$api
          .post("order/member/order/confirm", {
            //确认订单 （即验舱验价）
            order: {
              //类型：Object  必有字段  备注：主订单必传参数
              type: "air", //类型：String  必有字段  备注：订单类型 线上订单：onorder, 扫码订单：scan_order,线下报单：declaration_order,机票：air,酒店：hotel,投资：investment,京东：jingdong,淘宝：taobao,油卡：oil,话费流量：rechargemobile,汽车：car，充值订单：recharge，会员升级：member_grade
            },
            flight_nos: this.planeLists.info.flight_no, //类型：String  必有字段  备注：航疤痕
            query_id: sessionStorage.getItem("query_id"), //类型：String  必有字段  备注：查询id 取航班列表接口返回query_id
            flight_id: sessionStorage.getItem("flight_id"), //类型：String  必有字段  备注：航班缓存id 取舱位接口返回query_id
            cabin_code: this.planeLists.price.cabin_code, //类型：String  必有字段  备注：取自舱位列表接口的cabin_code
            vendor_id: this.planeLists.price.vendor_id, //类型：String  必有字段  备注：供应商ID,取自舱位列表接口vendor_id
            fare_breakdown_list: this.planeLists.info.fare_breakdown_list, //类型：String  必有字段  备注：取自航班列表接口 fare_breakdown_list
            spec_vendor_id: this.planeLists.price.spec_vendor_id, //类型：String  必有字段  备注：取自舱位列表接口spec_vendor_id
            price_info_id: this.planeLists.price.price_info_id, //类型：String  必有字段  备注：取自舱位列表接口price_info_id
            adult_quantity: this.adults.length, //类型：Number  必有字段  备注：成人数
            child_quantity: this.childs.length, //类型：Number  必有字段  备注：儿童数 没有默认传0
            baby_quantity: this.babys.length, //类型：Number  必有字段  备注：婴儿数 没有默认传0
            baggage_info: this.planeLists.price.baggage_info,
          })
          .then((res) => {
            var touristList_1 = [];
            //乘客信息列表
            for (let i in this.passengerLists) {
              var jsons =
                //类型：Array  必有字段  备注：乘客列表
                {
                  birthday: this.passengerLists[i].birthday, //类型：String  必有字段  备注：生日
                  name: this.passengerLists[i].name, //类型：String  必有字段  备注：姓名
                  pspt_id: this.passengerLists[i].id_number, //类型：String  必有字段  备注：证件号码
                  pspt_type: this.passengerLists[i].id_type, //类型：Number  必有字段  备注：默认1:二代身份证：证件类型：1:二代身份证、2：护照、3：军官证、4：港澳通行证、7：台胞证、8：回乡证、9：户口簿、10：出生证明、11：台湾通行证
                  tourist_type: this.passengerLists[i].person_type, //类型：Number  必有字段  备注：乘客类型 1：成人 2：儿童 3婴儿
                  tel: this.passengerLists[i].phone, //类型：String  必有字段  备注：电话
                  sex: this.passengerLists[i].gender, //类型：Number  必有字段  备注：性别 1：男 2：女
                };
              touristList_1.push(jsons);
            }
            //创建订单参数
            if (this.iscq) {
              var params = {
                order: {
                  //类型：Object  必有字段  备注：主订单必传参数
                  type: "air", //类型：String  必有字段  备注：订单类型 线上订单：onorder, 扫码订单：scan_order,线下报单：declaration_order,机票：air,酒店：hotel,投资：investment,京东：jingdong,淘宝：taobao,油卡：oil,话费流量：rechargemobile,汽车：car，充值订单：recharge，会员升级：member_grade
                  client: this.client, //类型：Number  必有字段  备注：客户端类型 10：安卓 11：APPIOS 12：wap 13：小程序 20：pc
                  confirm: res.order.confirm, //类型：Array  必有字段  备注：订单确认信息（以下信息有确认订单接口原封不动的返回即可）
                },
                order_data: JSON.stringify(res.order_data), //类型：Object  必有字段  备注：取验舱验价order_data
                tourist_list: touristList_1, //类型：Array  必有字段  备注：乘客列表
                contact: {
                  //类型：Object  必有字段  备注：联系信息
                  name: this.contact, //类型：String  必有字段  备注：联系人
                  tel: this.tel, //类型：String  必有字段  备注：联系电话
                  pspt_type: 1, //证件类型
                  pspt_id: this.iscqzjh, //身份证号
                },
                flight_info: JSON.stringify(this.planeLists.info), //类型：Object  必有字段  备注：航班信息 取航班列表下的flight_list中 选择乘机的航班完整的传入
                xb_price: res.xb_price, //确认订单 （即验舱验价）返回的参数
                flight_nos: this.planeLists.info.flight_no, //类型：String  必有字段  备注：航疤痕
                query_id: sessionStorage.getItem("query_id"), //类型：String  必有字段  备注：查询id 取航班列表接口返回query_id
                flight_id: sessionStorage.getItem("flight_id"), //类型：String  必有字段  备注：航班缓存id 取舱位接口返回query_id
                cabin_code: this.planeLists.price.cabin_code, //类型：String  必有字段  备注：取自舱位列表接口的cabin_code
                vendor_id: this.planeLists.price.vendor_id, //类型：String  必有字段  备注：供应商ID,取自舱位列表接口vendor_id
                fare_breakdown_list: this.planeLists.info.fare_breakdown_list, //类型：String  必有字段  备注：取自航班列表接口 fare_breakdown_list
                spec_vendor_id: this.planeLists.price.spec_vendor_id, //类型：String  必有字段  备注：取自舱位列表接口spec_vendor_id
                price_info_id: this.planeLists.price.price_info_id, //类型：String  必有字段  备注：取自舱位列表接口price_info_id
                adult_quantity: this.adults.length, //类型：Number  必有字段  备注：成人数
                child_quantity: this.childs.length, //类型：Number  必有字段  备注：儿童数 没有默认传0
                baby_quantity: this.babys.length,
              };
            } else {
              var params = {
                order: {
                  //类型：Object  必有字段  备注：主订单必传参数
                  type: "air", //类型：String  必有字段  备注：订单类型 线上订单：onorder, 扫码订单：scan_order,线下报单：declaration_order,机票：air,酒店：hotel,投资：investment,京东：jingdong,淘宝：taobao,油卡：oil,话费流量：rechargemobile,汽车：car，充值订单：recharge，会员升级：member_grade
                  client: this.client, //类型：Number  必有字段  备注：客户端类型 10：安卓 11：APPIOS 12：wap 13：小程序 20：pc
                  confirm: res.order.confirm, //类型：Array  必有字段  备注：订单确认信息（以下信息有确认订单接口原封不动的返回即可）
                },
                order_data: JSON.stringify(res.order_data), //类型：Object  必有字段  备注：取验舱验价order_data
                tourist_list: touristList_1, //类型：Array  必有字段  备注：乘客列表
                contact: {
                  //类型：Object  必有字段  备注：联系信息
                  name: this.contact, //类型：String  必有字段  备注：联系人
                  tel: this.tel, //类型：String  必有字段  备注：联系电话
                },
                flight_info: JSON.stringify(this.planeLists.info), //类型：Object  必有字段  备注：航班信息 取航班列表下的flight_list中 选择乘机的航班完整的传入
                xb_price: res.xb_price, //确认订单 （即验舱验价）返回的参数
                flight_nos: this.planeLists.info.flight_no, //类型：String  必有字段  备注：航疤痕
                query_id: sessionStorage.getItem("query_id"), //类型：String  必有字段  备注：查询id 取航班列表接口返回query_id
                flight_id: sessionStorage.getItem("flight_id"), //类型：String  必有字段  备注：航班缓存id 取舱位接口返回query_id
                cabin_code: this.planeLists.price.cabin_code, //类型：String  必有字段  备注：取自舱位列表接口的cabin_code
                vendor_id: this.planeLists.price.vendor_id, //类型：String  必有字段  备注：供应商ID,取自舱位列表接口vendor_id
                fare_breakdown_list: this.planeLists.info.fare_breakdown_list, //类型：String  必有字段  备注：取自航班列表接口 fare_breakdown_list
                spec_vendor_id: this.planeLists.price.spec_vendor_id, //类型：String  必有字段  备注：取自舱位列表接口spec_vendor_id
                price_info_id: this.planeLists.price.price_info_id, //类型：String  必有字段  备注：取自舱位列表接口price_info_id
                adult_quantity: this.adults.length, //类型：Number  必有字段  备注：成人数
                child_quantity: this.childs.length, //类型：Number  必有字段  备注：儿童数 没有默认传0
                baby_quantity: this.babys.length,
              };
            }
            //订单创建地址 效验完成创建订单
            this.$api
              .post("/order/member/order/create", params)
              .then((res) => {
                this.submintShow = true;
                let timerNum = 0;
                let timer = setInterval(() => {
                  timerNum++;
                  if (timerNum == 1) {
                    this.loadingItem1 = true;
                  } else if (timerNum == 2) {
                    this.loadingItem2 = true;
                  } else if (timerNum == 3) {
                    this.loadingItem3 = true;
                  } else if (timerNum == 4) {
                    this.loadingItem4 = true;
                  } else if (timerNum == 5) {
                    this.loadingItem5 = false;
                    this.loadingItem6 = true;
                  } else {
                    this.submintShow = false;
                    clearInterval(timer);
                    this.loadingItem1 = false;
                    this.loadingItem2 = false;
                    this.loadingItem3 = false;
                    this.loadingItem4 = false;
                    this.loadingItem5 = true;
                    this.loadingItem6 = false;

                    this.orderInfo = JSON.stringify(res);
                    if (this.$route.path == "/submit/order") {
                      //this.$route.path//path: "/submit/order"
                      this.$refs.btn.click();
                      this.createOrder = false;
                    }
                  }
                }, 700);
              })
              .catch((err) => {
                let keys = Object.keys(err);
                let key = keys[0];
                let message = err.message || err[key][0];
                //        this.$toast(message);
                this.createOrder = false;
                if (message.slice(0, 10) == "timeout of") {
                  this.$toast("网络不给力，请稍候重试");
                } else if (
                  message.slice(0, 20) ==
                  "机票下单失败：国内订单占位失败：存在乘客"
                ) {
                  //"机票下单失败：国内订单占位失败：存在乘客[朱海丽]重复下单"
                  this.order_already = 1; //弹框只显示一个确认按钮
                  this.showPopup(
                    "本次航班订单已存在，请前往订单详情页进行确认",
                    4
                  );
                } else if (
                  message.slice(0, 22) ==
                  "机票下单失败：国内订单占位失败：订单重复提交"
                ) {
                  //"机票下单失败：国内订单占位失败：订单重复提交"     原因：查询id（取航班列表接口返回query_id）  或   航班缓存id（取舱位接口返回query_id 重复使用导致的）
                  this.order_already = 1; //弹框只显示一个确认按钮
                  this.showPopup(
                    "本次航班订单已存在，请前往订单详情页进行确认",
                    4
                  );
                } else if (
                  message.slice(0, 16) == "验舱验价失败:成人价格找不到运价"
                ) {
                  this.order_already = 1; //弹框只显示一个确认按钮
                  this.showPopup("很抱歉，该价格舱位已售完，请重新搜索", 1);
                } else {
                  this.$toast(message);
                }
              });
          })
          .catch((err) => {
            let keys = Object.keys(err);
            let key = keys[0];
            let message = err.message || err[key][0];
            this.createOrder = false;
            if (message.slice(0, 10) == "timeout of") {
              this.$toast("网络不给力，请稍候重试");
            } else if (message == "验舱验价失败:缓存信息已失效，请重新查询") {
              this.order_already = 2; //弹框显示两个按钮（取消和确认）
              this.showPopup("机票信息发生变化，点击确定返回航班列表", 2);
            } else if (message == "验舱失败:指定舱位余位不足") {
              this.order_already = 2; //弹框显示两个按钮（取消和确认）
              this.showPopup(
                "来晚啦，指定舱位不足，点击确定返回舱位列表页面",
                1
              );
            } else if (message == "验舱验价失败:成人价格找不到运价") {
              this.order_already = 2; //弹框显示两个按钮（取消和确认）
              this.showPopup("很抱歉，该价格舱位已售完，请重新搜索", 1);
            } else {
              this.order_already = 2; //弹框显示两个按钮（取消和确认）
              this.showPopup(message, 0);
            }
          });
      }
    },
    transform(str) {
      if (str.length == 6) {
        return str.substr(0, 1) + ":" + str.substr(3, 2);
      } else if (str.length == 7) {
        return str.substr(0, 2) + ":" + str.substr(4, 2);
      }
    },
    priceDetail() {
      this.spacePop = !this.spacePop;
    },
    toPay() {
      this.params(this.orderInfo, this.orderInfo, "toPay");
    },
    account() {
      if (this.passengerLists && this.passengerLists.length > 0) {
        if (!this.isChecked) {
          this.loading = true;
        }

        var grown_up = [];
        var Teenagers = [];
        this.adults = 0;
        this.childs = 0;
        this.babys = 0;
        this.adults = this.passengerLists.filter(function (item) {
          if (item.adult == "成人") {
            return item;
          }
        });
        this.grown_up = this.passengerLists.filter(function (item) {
          if (item.adult == "成人") {
            var millisecond =
              new Date("2019-01-01").getTime() -
              new Date("2001-01-01").getTime();
            var idNum =
              item.id_number.slice(6, 10) +
              "-" +
              item.id_number.slice(10, 12) +
              "-" +
              item.id_number.slice(12, 14);
            var times2 = new Date().getTime() - new Date(idNum).getTime();
            if (times2 >= millisecond) {
              //大于18岁
              return item;
            }
          }
        });
        this.Teenagers = this.passengerLists.filter(function (item) {
          if (item.adult == "成人") {
            var millisecond =
              new Date("2019-01-01").getTime() -
              new Date("2001-01-01").getTime();
            var idNum =
              item.id_number.slice(6, 10) +
              "-" +
              item.id_number.slice(10, 12) +
              "-" +
              item.id_number.slice(12, 14);
            var times2 = new Date().getTime() - new Date(idNum).getTime();
            if (times2 < millisecond) {
              //青少年12~18岁
              return item;
            }
          }
        });
        this.childs = this.passengerLists.filter(function (item) {
          if (item.adult == "儿童") {
            return item;
          }
        });
        this.babys = this.passengerLists.filter(function (item) {
          if (item.adult == "婴儿") {
            return item;
          }
        });

        if (
          this.grown_up.length <= 0 &&
          this.Teenagers.length <= 0 &&
          (this.childs.length > 0 || this.babys.length > 0)
        ) {
          //成人小于0，青年小于0，有婴儿或儿童
          this.notBuyOfNum = true;
          this.toastMsg =
            "出票的儿童旅客或婴儿旅客必须有一名 18 周岁以上具有完全民事行为能力的成年旅客陪伴乘机";
        } else if (this.grown_up.length <= 0 && this.Teenagers.length > 0) {
          //成人小于0，青年大于0
          if (this.childs.length > 0 || this.babys.length > 0) {
            //有婴儿或儿童
            this.notBuyOfNum = true;
            this.toastMsg =
              "出票的儿童旅客或婴儿旅客必须有一名 18 周岁以上具有完全民事行为能力的成年旅客陪伴乘机";
          } else {
            //无儿童和婴儿
            if (this.Teenagers.length > this.max_preson) {
              this.notBuyOfNum = true;
              this.toastMsg = "剩余舱位不足，请修改乘机人";
            }
          }
        } else if (this.grown_up.length > 0) {
          //成人大于0时（一个成人只能携带一名婴儿或两名儿童或一名婴儿一名儿童）
          if (
            this.childs.length > 0 &&
            Number(this.grown_up.length) +
              Number(this.childs.length) +
              Number(this.Teenagers.length) >
              this.max_preson
          ) {
            //
            this.notBuyOfNum = true;
            this.toastMsg = "成人加儿童数量不能大于可添加人数，请修改乘机人";
          } else if (
            Number(this.grown_up.length) + Number(this.Teenagers.length) >
            this.max_preson
          ) {
            this.notBuyOfNum = true;
            this.order_already = 1; //弹框只显示一个确认按钮
            this.showPopup("成人舱位不足，请修改乘机人", 0);
            // this.toastMsg = '成人舱位不足，请修改乘机人';
          } else if (this.childs.length > this.max_child) {
            this.notBuyOfNum = true;
            this.toastMsg = "儿童舱位不足，请修改乘机人";
          } else if (this.babys.length > this.max_baby) {
            this.notBuyOfNum = true;
            this.toastMsg = "婴儿舱位不足，请修改乘机人";
          } else if (
            this.babys.length > 0 &&
            this.babys.length > this.grown_up.length
          ) {
            this.notBuyOfNum = true;
            this.toastMsg = "每名成人携带的婴儿总数不能超过1人，请修改乘机人";
          } else if (
            this.childs.length > 0 &&
            this.babys.length == 0 &&
            this.childs.length / 2 > this.grown_up.length
          ) {
            this.notBuyOfNum = true;
            this.toastMsg = "每名成人携带的儿童的总数不能超过2人，请修改乘机人";
          } else if (
            this.childs.length > 0 &&
            this.babys.length > 0 &&
            (Number(this.childs.length) + Number(this.babys.length)) / 2 >
              this.grown_up.length
          ) {
            this.notBuyOfNum = true;
            this.toastMsg =
              "每名成人携带的儿童和婴儿的总数不能超过2人，请修改乘机人";
          }
        }

        this.proceDetail[0].length = this.adults.length;
        this.proceDetail[1].length = this.childs.length;
        this.proceDetail[2].length = this.babys.length;
        //验舱验价
        if (!this.isChecked) {
          this.checkPrice();
        } else {
          this.amountes =
            this.adults.length * this.proceDetail[0].adultPrice +
            this.childs.length * this.proceDetail[1].childPrice +
            this.babys.length * this.proceDetail[2].babyPrice;
        }
      } else {
        this.amountes = 0;
      }
    },
    checkPrice() {
      this.$api
        .post("/air/member/order/check", {
          flight_nos: this.planeLists.info.flight_no, //类型：String  必有字段  备注：航疤痕
          query_id: sessionStorage.getItem("query_id"), //类型：String  必有字段  备注：查询id 取航班列表接口返回query_id
          flight_id: sessionStorage.getItem("flight_id"), //类型：String  必有字段  备注：航班缓存id 取舱位接口返回query_id
          cabin_code: this.planeLists.price.cabin_code, //类型：String  必有字段  备注：取自舱位列表接口的cabin_code
          vendor_id: this.planeLists.price.vendor_id, //类型：String  必有字段  备注：供应商ID,取自舱位列表接口vendor_id
          fare_breakdown_list: this.planeLists.info.fare_breakdown_list, //类型：String  必有字段  备注：取自航班列表接口 fare_breakdown_list
          spec_vendor_id: this.planeLists.price.spec_vendor_id, //类型：String  必有字段  备注：取自舱位列表接口spec_vendor_id
          price_info_id: this.planeLists.price.price_info_id, //类型：String  必有字段  备注：取自舱位列表接口price_info_id
          adult_quantity: this.adults.length, //类型：Number  必有字段  备注：成人数
          child_quantity: this.childs.length, //类型：Number  必有字段  备注：儿童数 没有默认传0
          baby_quantity: this.babys.length,
        })
        .then((res) => {
          var orderCheckData = res.order_data;
          this.amountes = res.xb_price;
          this.loading = false;
          this.proceDetail[0].price = res.xb_adult_base_price;
          this.proceDetail[0].fuel_tax =
            orderCheckData.adultTax + orderCheckData.adultFuel;
          this.proceDetail[0].adultPrice =
            this.proceDetail[0].price + this.proceDetail[0].fuel_tax;
          this.proceDetail[1].price = res.xb_child_base_price;
          this.proceDetail[1].fuel_tax =
            orderCheckData.childTax + orderCheckData.childFuel;
          this.proceDetail[1].childPrice =
            this.proceDetail[1].price + this.proceDetail[1].fuel_tax;
          this.proceDetail[2].price = res.xb_baby_base_price;
          this.proceDetail[2].fuel_tax =
            orderCheckData.babyTax + orderCheckData.babyFuel;
          this.proceDetail[2].babyPrice =
            this.proceDetail[2].price + this.proceDetail[2].fuel_tax;
        })
        .catch((err) => {
          this.hascabin = false;
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          //	      this.$toast(message);
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else if (message == "验舱验价失败:缓存信息已失效，请重新查询") {
            this.order_already = 2; //弹框显示两个按钮（取消和确认）
            this.showPopup("机票信息发生变化，点击确定返回航班列表", 2);
          } else if (message == "验舱失败:指定舱位余位不足") {
            this.order_already = 2; //弹框显示两个按钮（取消和确认）
            this.showPopup("来晚啦，指定舱位不足，点击确定返回舱位列表页面", 1);
          } else if (message == "验舱验价失败:成人价格找不到运价") {
            this.order_already = 2; //弹框显示两个按钮（取消和确认）
            this.showPopup("很抱歉，该价格舱位已售完，请重新搜索", 1);
          } else {
            this.order_already = 2; //弹框显示两个按钮（取消和确认）
            //		  this.$toast(message);
            this.showPopup(message, 0);
          }
          this.amountes = 0;
          this.loading = false;
          return;
        });
    },
    // 联系人输入框获得焦点，增加padding不被遮挡
    keyboard() {
      // 判断是否为ios
      var u = navigator.userAgent;
      if (u.indexOf("iPhone") > -1 || u.indexOf("iOS") > -1) {
        //IOS
        // console.log("ios")
      } else {
        //安卓
        this.iskeyboard = true;
        window.setTimeout(function () {
          document.activeElement.scrollIntoView({ block: "center" });
        }, 200);
      }
    },
    // 函数参数必须是字符串，因为二代身份证号码是十八位，而在javascript中，十八位的数值会超出计算范围，造成不精确的结果，导致最后两位和计算的值不一致，从而该函数出现错误。
    // 详情查看javascript的数值范围
    checkIDCard(idcode) {
      // 加权因子
      var weight_factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
      // 校验码
      var check_code = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"];
      var code = idcode + "";
      var last = idcode[17]; //最后一位
      var seventeen = code.substring(0, 17);

      // ISO 7064:1983.MOD 11-2
      // 判断最后一位校验码是否正确
      var arr = seventeen.split("");
      var len = arr.length;
      var num = 0;
      for (var i = 0; i < len; i++) {
        num = num + arr[i] * weight_factor[i];
      }

      // 获取余数
      var resisue = num % 11;
      var last_no = check_code[resisue];

      // 格式的正则
      // 正则思路
      /*
      第一位不可能是0
      第二位到第六位可以是0-9
      第七位到第十位是年份，所以七八位为19或者20
      十一位和十二位是月份，这两位是01-12之间的数值
      十三位和十四位是日期，是从01-31之间的数值
      十五，十六，十七都是数字0-9
      十八位可能是数字0-9，也可能是X
      */
      var idcard_patter =
        /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X,x])$/;

      // 判断格式是否正确
      var format = idcard_patter.test(idcode);

      // 返回验证结果，校验码和格式同时正确才算是合法的身份证号码
      return last === last_no && format ? true : false;
    },
  },
  //computed: {
  //  amountes() {
  //
  //  }
  //},
  mounted() {
    //  this.getInsurance();
    this.account();
  },
};
</script>

<style lang="less" scoped>
.plane {
  &-submit-order {
    height: 100%;
    background: #f2f2f2;
    .submit {
      z-index: 2000;
      height: 48px;
      line-height: 48px;
      background: #fff;
      color: #333;
      font-size: 13px;
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      p {
        padding: 0 10px;
        .money {
          color: #e6212f;
          font-size: 9px;
          .price {
            font-size: 14px;
          }
          .decimal {
            font-size: 9px;
          }
        }
        .detailed {
          margin-left: 14px;
          color: #999;
          font-size: 10px;
          img {
            width: 9px;
            margin-left: 3px;
            vertical-align: middle;
          }
        }
        .btn {
          width: 104px;
          height: 35px;
          line-height: 35px;
          font-size: 15;
          color: #fff;
          float: right;
          text-align: center;
          border-radius: 18px;
          margin-top: 6px;
          background: -webkit-linear-gradient(
            #feac7a,
            #ff6059
          ); /* Safari 5.1 - 6.0 */
          background: -o-linear-gradient(
            #feac7a,
            #ff6059
          ); /* Opera 11.1 - 12.0 */
          background: -moz-linear-gradient(
            #feac7a,
            #ff6059
          ); /* Firefox 3.6 - 15 */
          background: linear-gradient(
            #feac7a,
            #ff6059
          ); /* 标准的语法（必须放在最后） */
        }
        .btn1 {
          padding: 0 11px;
          border: none;
          .van-button__loading {
            text-align: left;
          }
          .van-button__text {
            text-align: left;
            margin: 0;
          }
        }
      }
    }
    .van-popup--bottom {
      height: auto;
      bottom: 48px;
      padding-bottom: 10px;
      border-bottom: solid 1px #e2e2e2;
      .title {
        color: #333;
        font-size: 13px;
        text-align: left;
        height: 28px;
        line-height: 28px;
        margin-top: 9px;
        font-weight: 700;
        padding: 0 11px;
      }
      .list {
        color: #999;
        font-size: 12px;
        padding: 0 11px;
        height: 28px;
        line-height: 28px;
        .right {
          float: right;
          width: 103px;
          color: #e6212f;
          text-align: left;
          span {
            float: right;
            color: #999;
          }
        }
      }
    }
    .tipMSG {
      width: 70%;
      border-radius: 10px;
      .box {
        img {
          display: block;
          width: 100%;
        }
        .title {
          color: #333;
          font-size: 15px;
          font-weight: 600;
          line-height: 47px;
          margin-top: 8px;
          text-align: center;
        }
        .tips {
          color: #333;
          font-size: 13px;
          line-height: 18px;
          text-align: center;
          margin-bottom: 30px;
          padding: 0 10px;
        }
        span {
          float: left;
          width: 50%;
          border-top: solid 1px #f2f2f2;
          line-height: 43px;
          color: #999;
          font-size: 14px;
          text-align: center;
          display: inline-block;
        }
        .right {
          color: #e6212f;
          width: calc(50% - 1px);
          border-left: solid 1px #f2f2f2;
        }
        .right_big {
          width: 100%;
          border-left: none;
        }
      }
    }
    .detailTitle {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 2000;
      padding: 0;
      width: 100%;
      padding-top: 35px;
      height: 50px;
      line-height: 50px;
      background: #f2f2f2;
      .back {
        width: 17px;
        padding: 8px;
        position: fixed;
        top: 45px;
        left: 8px;
        z-index: 9;
      }
      .target {
        padding: 6px 16px;
        text-align: center;
        height: 50px;
        p {
          img {
            width: 30px;
            padding: 5px 6px;
          }
        }
        .space {
          height: 21px;
          line-height: 21px;
        }
        .date {
          height: 16px;
          line-height: 16px;
          font-size: 12px;
        }
      }
    }
    .allList {
      padding: 85px 11px 0;
      background: #f2f2f2;
      .msg {
        background: #fff;
        border-radius: 10px;
        margin-bottom: 7px;
        box-shadow: #e3e3e3 2px 0 4px;
        padding: 0 10px;
        position: relative;
        height: 150px;
        .delect {
          width: 63px;
          height: 125px;
          line-height: 125px;
          color: #fff;
          font-size: 14px;
          text-align: center;
          background: #ff6059;
          position: absolute;
          top: 0;
          right: 0;
          border-top-right-radius: 10px;
          border-bottom-right-radius: 10px;
        }
        .oilList {
          .company {
            color: #666;
            font-size: 13px;
            height: 31px;
            line-height: 36px;
            overflow: hidden;
            border-bottom: solid 1px #f2f2f2;
            img {
              width: 14px;
              float: left;
              margin-top: 9px;
            }
            .name {
              padding: 0 15px 0 7px;
            }
            .right {
              float: right;
              text-align: center;
              color: #666;
              font-size: 13px;
              .reback {
                color: #333;
                font-size: 11px;
                padding: 2px;
                background: #ffc663;
                border-radius: 3px;
                margin-right: 2px;
                margin-left: 8px;
              }
            }
          }
          .airline {
            text-align: center;
            padding: 0 8px;
            p {
              display: flex;
              justify-content: space-between;
              align-items: center;
            }
            span {
              display: inline;
              text-align: center;
              color: #666;
              font-size: 13px;
            }
            .edge {
              text-align: center;
              display: inline-block;
              span {
                display: inline-block;
              }
              .date {
                color: #333;
                margin-top: 5px;
              }
              .city {
                color: #333;
                font-size: 17px;
                height: 34px;
                line-height: 34px;
                display: block;
              }
              .time {
                height: 18px;
                line-height: 18px;
                display: block;
              }
              .airport {
                height: 19px;
                line-height: 19px;
                margin-bottom: 12px;
                display: block;
              }
            }
            .middle {
              width: 97px;
              display: inline-block;
              vertical-align: bottom;
              padding-bottom: 17px;
              span {
                width: 97px;
                height: 18px;
                line-height: 19px;
                border-radius: 9px;
                color: #fff;
                font-size: 13px;
                background: #feab7a;
                text-align: center;
                display: inline-block;
                margin-bottom: 16px;
              }
              img {
                width: 97px;
                display: block;
              }
            }
            @media screen and (max-width: 350px) {
              .middle {
                padding: 0 14px 17px 14px;
              }
            }
          }
        }
      }
      .fuelOil {
        height: 52px;
        line-height: 52px;
        font-size: 13px;
        margin-bottom: 7px;
        border-radius: 10px;
        padding: 0 10px;
        span {
          float: right;
          color: #e6212f;
        }
      }
      .opportunityPerson {
        background: #fff;
        border-radius: 10px;
        margin-bottom: 7px;
        box-shadow: #e3e3e3 2px 0 4px;
        padding: 0 10px;
        p {
          font-size: 12px;
          color: #666;
          text-align: right;
          padding-left: 58px;
          position: relative;
          height: 52px;
          line-height: 52px;
          img {
            width: 11px;
            margin-right: 8px;
            float: right;
            margin-top: 21px;
          }
          .right {
            float: right;
            .surplus {
              margin: 0 15px 0 12px;
            }
            @media screen and (max-width: 320px) {
              .surplus {
                margin: 0 3px 0 0;
              }
            }
          }
          .left {
            float: left;
            color: #333;
            font-size: 13px;
            position: absolute;
            top: 0;
            left: 0;
          }
          .cabinNumber {
            color: #e6212f;
            font-weight: normal;
          }
        }
        .passengers {
          display: flex;
          justify-content: space-between;
          line-height: 30px;
          font-size: 13px;
          color: #333;
        }
        .van-cell {
          height: 52px;
          line-height: 52px;
          padding: 0;
          color: #333;
          border-top: solid 1px #f2f2f2;
          .van-field__label {
            font-size: 13px;
          }
          @media screen and (max-width: 320px) {
            .van-field__label {
              width: 64px;
            }
          }
          .van-field__control {
            font-size: 12px;
          }
          input::-webkit-input-placeholder {
            /* WebKit, Blink, Edge */
            color: #999 !important;
          }
          input:-moz-placeholder {
            /* Mozilla Firefox 4 to 18 */
            color: #999 !important;
          }
          input::-moz-placeholder {
            /* Mozilla Firefox 19+ */
            color: #999 !important;
          }
          input:-ms-input-placeholder {
            /* Internet Explorer 10-11 */
            color: #999 !important;
          }
        }
      }
      .Insurance {
        margin-bottom: 15px;
        border-radius: 10px;
        padding: 0 10px;
        p {
          height: 52px;
          line-height: 52px;
          color: #333;
          font-size: 13px;
          img {
            width: 12px;
            float: left;
            margin-right: 6px;
            margin-top: 19px;
          }
          span {
            float: right;
            img {
              width: 14px;
              margin-left: 10px;
              float: right;
              margin-top: 18px;
            }
          }
          .van-dialog {
            box-sizing: border-box;
            border-radius: 10px;
            padding: 0 10px;
            .van-dialog__header {
              padding-top: 0;
              height: 52px;
              font-size: 14px;
              font-weight: 500;
              color: rgba(51, 51, 51, 1);
              line-height: 52px;
              border-bottom: 1px solid #e3e3e3;
              margin-bottom: 15px;
            }
            .van-dialog__content {
              .insurance_p {
                padding: 0 19px;
                height: 40px;
                line-height: 40px;
                font-size: 13px;
                color: rgba(51, 51, 51, 1);
              }
              .insurance_btn {
                margin-top: 39px;
                font-size: 14px;
                color: rgba(230, 33, 47, 1);
                text-align: center;
                border-top: 1px solid #e3e3e3;
              }
            }
            .van-dialog__footer {
              display: none;
            }
          }
        }
      }
      .agreement {
        font-size: 10px;
        background: #f2f2f2;
        padding: 0;
        .van-cell__value {
          position: relative;
          padding-left: 25px;
          font-size: 10px;
          line-height: 18px;
          color: #72748c;
          img {
            width: 14px;
            height: 14px;
            display: inline-block;
            position: absolute;
            transform: translateY(-50%);
            top: 50%;
            left: 0;
            z-index: 8;
          }
        }
      }
      .tip {
        font-size: 10px;
        padding: 0 0 75px;
        background: #f2f2f2;
        .title {
          line-height: 30px;
          margin-top: 4px;
          color: #72748c;
        }
        .con {
          line-height: 18px;
          color: #72748c;
        }
      }
    }
    .keyboard {
      padding: 85px 11px 200px;
    }
    .loading {
      text-align: center;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 9999;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.7);
      img {
        width: 35%;
        margin-top: 65%;
      }
    }
  }
}
.isiOSX {
  .detailTitle {
    padding-top: 55px;
    .back {
      top: 65px;
    }
  }
  .allList {
    padding-top: 115px;
  }
}
.submintShowStyle {
  text-align: center;
  padding: 0 0 20px 0;
  ul {
    margin: 0 20px;
    li {
      height: 42px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      font-size: 16px;
      color: #999999;
      span {
        color: #181818;
      }
      img {
        width: 16px;
      }
      div {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        img {
          margin-right: 10px;
        }
      }
    }
  }
  .turn {
    animation: turn 1s linear infinite;
  }
  @keyframes turn {
    0% {
      -webkit-transform: rotate(0deg);
    }
    50% {
      -webkit-transform: rotate(180deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
    }
  }
}
</style>
